module.exports = __webpack_public_path__ + "img/canada-lung-cancer-female.1568cdc7.png";